import IField from "@mapmycustomers/shared/types/fieldModel/IField";
import IFiltersConfig from "@mapmycustomers/shared/types/fieldModel/IFilterConfig";
import FilterModel from "@mapmycustomers/shared/types/viewModel/internalModel/FilterModel";

import { isSimpleCondition } from "@app/util/viewModel/assert";

const isUnsupportedFilter = (filter: Partial<FilterModel>, fields: IField[]) => {
  return fields.some((field) => {
    const condition = filter[field.filterName];
    if (!condition) {
      return false;
    }
    if (!isSimpleCondition(condition)) {
      return true; // we don't support combined conditions atm
    }
    const operator = condition.operator;
    if (!field.filter) {
      return true; // if field supports no filtering, we can't have it here...
    }
    const filterConfig = field.filter as IFiltersConfig;

    // if used operator is not one which field supports
    return !filterConfig.operators.some((config) => config.operator === operator);
  });
};

export default isUnsupportedFilter;
